import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/images/logo/mainlogo.png';
import Dataservice, { logindata } from '../service/dataservice';
import { toast } from "react-toastify";

export const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();

    const validate = () => {
        const errors = {};
        // Basic email regex for validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!email) {
            errors.email = "Email is required";
        } else if (!emailRegex.test(email)) {
            errors.email = "Invalid email format";
        }

        if (!password) {
            errors.password = "Password is required";
        } else if (password.length < 6) {
            errors.password = "Password must be at least 6 characters";
        }

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        localStorage.clear();
        if (validate()) {

            // navigate("/superadmin/dashboard");

            let data = new FormData();
            data.append("username", email);
            data.append("password", password);
            logindata(data).then((res) => {
                    if (res.status) {
                        localStorage.setItem('user_id',res.data.user_details.id)
                        localStorage.setItem('Role',res.data.user_details.role)
                        navigate("/superadmin/dashboard");
                    }
                    else toast.error(res.message);
                })
                .catch((err) => toast.error(err.message));


        }
    };

    return (
        <div style={styles.page}>
            <div style={styles.container}>
                <img src={logo} alt="Focus Logo" style={styles.logo} />
                <h2 style={styles.title}>Focus Dot Photography</h2>
                <form onSubmit={handleSubmit} style={styles.form} noValidate>
                    <label style={styles.label}>Email</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        style={styles.input}
                        placeholder="Enter your email"
                        required
                    />
                    {errors.email && <span style={styles.error}>{errors.email}</span>}

                    <label style={styles.label}>Password</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        style={styles.input}
                        placeholder="Enter your password"
                        required
                    />
                    {errors.password && <span style={styles.error}>{errors.password}</span>}

                    <button type="submit" style={styles.button}>
                        Login
                    </button>
                </form>
            </div>
        </div>
    );
};

const styles = {
    page: {
        height: '100vh',
        backgroundColor: '#0d5852',  // Dark teal background same as sidebar
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
    },
    container: {
        backgroundColor: '#ffffff',
        padding: '40px',
        borderRadius: '10px',
        boxShadow: '0 8px 16px rgba(0,0,0,0.15)',
        width: '400px',
        textAlign: 'center',
    },
    logo: {
        width: '120px',
        marginBottom: '20px',
    },
    title: {
        color: '#0d5852',  // Dark teal text to match branding
        marginBottom: '30px',
        fontWeight: '700',
        fontSize: '24px',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
    },
    label: {
        textAlign: 'left',
        fontWeight: '600',
        color: '#0d5852',
        fontSize: '14px',
    },
    input: {
        padding: '10px',
        borderRadius: '5px',
        border: '1.5px solid #0d5852',
        fontSize: '16px',
        outline: 'none',
        transition: 'border-color 0.3s',
    },
    button: {
        backgroundColor: '#00a82d',  // Bright green from cards
        color: 'white',
        padding: '12px',
        border: 'none',
        borderRadius: '7px',
        fontWeight: '700',
        fontSize: '16px',
        cursor: 'pointer',
        transition: 'background-color 0.3s',
        marginTop: '10px',
    },
    error: {
        color: 'red',
        fontSize: '12px',
        textAlign: 'left',
        marginTop: '-8px',
        marginBottom: '8px',
    },
};
